import { render, staticRenderFns } from "./StatisticsDocRatio.vue?vue&type=template&id=3a697839&"
import script from "./StatisticsDocRatio.vue?vue&type=script&lang=js&"
export * from "./StatisticsDocRatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports